import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function placeSQSMessageForBulkEmail(
  token: string,
  taskExecutionId: string,
) {
  try {
    const response = await instance({
      method: 'POST',
      url: `/api/v1/bulk-email/send/notification`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { taskExecutionId },
    });

    return response.data.message;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
